export default {

    ready: (state) => {
        return (state.accepted.length > 0 || state.accepted.length > 0 || state.transfered.length > 0)
    },

    accepted: (state, getters, rootState, rootGetters) => {
        let results = []
        try {
            let track = rootGetters['v4/track/current']
            let panels = track.panels
            results = state.accepted.reduce((acc, cur) => {
                let panel = panels.find(panel => panel.name === cur.name)
                if (panel && cur.display !== false) {
                    panel = JSON.parse(JSON.stringify(panel))
                    panel.collections = 'accepted'
                    acc.push(panel)
                }
                return acc
            }, [])
        }
        catch (e) {
            console.log(e)
        }
        return results
    },

    transfered: (state, getters, rootState, rootGetters) => {
        let results = []
        try {
            let track = rootGetters['v4/track/current']
            let panels = track.panels
            results = state.transfered.reduce((acc, cur) => {
                let panel = panels.find(panel => panel.name === cur.name)
                if (panel && cur.display !== false) {
                    panel = JSON.parse(JSON.stringify(panel))
                    panel.collections = 'transfered'
                    acc.push(panel)
                }
                return acc
            }, [])
        }
        catch (e) {
            console.log(e)
        }
        return results
    },

    rejected: (state, getters, rootState, rootGetters) => {
        let results = []
        try {
            let track = rootGetters['v4/track/current']
            let panels = track.panels
            results = state.rejected.reduce((acc, cur) => {
                let panel = panels.find(panel => panel.name === cur.name)
                if (panel && cur.display !== false) {
                    panel = JSON.parse(JSON.stringify(panel))
                    panel.collections = 'rejected'
                    acc.push(panel)
                }
                return acc
            }, [])
        }
        catch (e) {
            console.log(e)
        }
        return results
    },

}
